import { App } from '@grafikr/components';

import './css/app.css';
import './js/vendor/lazysizes';

import components from './js/framework/components';
import state from './js/framework/state';
import tracking from './js/framework/tracking';


const app = new App();
components(app);
state(app);
app.mount();
tracking();

document.addEventListener('shopify:section:load', ({ detail }) => {
  const section = document.getElementById(`shopify-section-${detail.sectionId}`);

  if (section) {
    app.mount(section);
  }
});

document.addEventListener('appMount', () => {
  app.mount();
});
